<app-rihappy-optout *ngIf="dadosOptout.Empresa == 1" [dadosOptout]="dadosOptout"></app-rihappy-optout>
<app-pbkids-optout *ngIf="dadosOptout.Empresa == 2" [dadosOptout]="dadosOptout"></app-pbkids-optout>